import { createContext } from "react";
import { Lot, Project, Stage } from "../../api/dtos";

export interface ILinkContext {

    projectLinkEnabled: boolean;
    createProjectLink: (project: Project | undefined) => string;
    setCreateProjectLink: (createLink?: (project: Project | undefined) => string) => void;
    setProjectLinkEnabled: (enabled?: boolean) => void;

    stageLinkEnabled: boolean;
    createStageLink: (project: Project | undefined, stage: Stage | undefined) => string;
    setCreateStageLink: (createLink?: (project: Project | undefined, stage: Stage | undefined) => string) => void;
    setStageLinkEnabled: (enabled?: boolean) => void;

    lotLinkEnabled: boolean;
    createLotLink: (project: Project | undefined, stage: Stage | undefined, lot: Lot | undefined) => string;
    setCreateLotLink: (createLink?: (project: Project | undefined, stage: Stage | undefined, lot: Lot | undefined) => string) => void;
    setLotLinkEnabled: (enabled?: boolean) => void;
}

export const DefaultProjectCreateLink = (project: Project | undefined) => {
    if(project == null) {
        return "/projects";
    }
    return `/projects/${project.id}`;
};

export const DefaultStageCreateLink = (project: Project | undefined, stage: Stage | undefined) => {
    if(project == null) {
        return "/projects";
    }

    if (stage == null) {
        return `/projects/${project.id}`;
    }

    return `/projects/${project.id}/stages/${stage.id}`
};

export const DefaultLotCreateLink = (project: Project | undefined, stage: Stage | undefined, lot: Lot | undefined) => {
    if(project == null) {
        return "/projects";
    }
    if(stage == null) {
        return `/projects/${project.id}/`;
    }
    if(lot == null) {
        return `/projects/${project.id}/stages/${stage.id}`;
    }
    return `/projects/${project.id}/stages/${stage.id}/lots/${lot.id}`
};

export const StagePlanPreviewStageCreateLink = (project: Project | undefined, stage: Stage | undefined) => {
    if(project == null) {
        return "/projects";
    }
    if(stage == null) {
        return `/projects/${project.id}`;
    }
    return `/projects/${project.id}/stages/${stage.id}/stage-plan`;
}

export const StagePlanEditStageCreateLink = (project: Project | undefined, stage: Stage | undefined) => {
    if(project == null) {
        return "/projects";
    }
    if(stage == null) {
        return `/projects/${project.id}`;
    }
    return `/projects/${project.id}/stages/${stage.id}/stage-plan/edit`;
}

export const LotPropertyProjectCreateLink = (project: Project | undefined) => {
    if(project == null) {
        return "/projects";
    }
    return `/projects/${project.id}/bulk-edit-lot-properties`;
};

export const LotPropertyStageCreateLink = (project: Project | undefined, stage: Stage | undefined) => {
    if(project == null) {
        return "/projects";
    }

    if (stage == null) {
        return `/projects/${project.id}/bulk-edit-lot-properties`;
    }

    return `/projects/${project.id}/stages/${stage.id}/bulk-edit-lot-properties`
};

export const LinkContext = createContext<ILinkContext>({
    projectLinkEnabled: true,
    createProjectLink: DefaultProjectCreateLink,
    setCreateProjectLink: () => {

    },
    setProjectLinkEnabled: () => {

    },

    stageLinkEnabled: true,
    createStageLink: DefaultStageCreateLink,
    setCreateStageLink: () => {

    },
    setStageLinkEnabled: () => {

    },

    lotLinkEnabled: true,
    createLotLink: DefaultLotCreateLink,
    setCreateLotLink: () => {

    },
    setLotLinkEnabled: () => {

    }
})